import { ObjectValues } from "helpers/types";

export const STYLE_VARIANTS = {
  CONTAINED: 'contained',
  OUTLINED: 'outlined'
} as const;

export type IStyleVariants = ObjectValues<typeof STYLE_VARIANTS>;